import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function WorkspacePremiumIcon(props: IconProps) {
    return <Icon {...props} iconKey={"workspace_premium"}/>
}
